import ConfirmDialog from 'Components/ConfirmDialog';

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DIALOG_TITLE = 'Solicitar oportunidad adicional';
const DIALOG_DESCRIPTION = '¿Deseas solicitar una nueva oportunidad para esta evaluación?';

/**
 * Confirmation dialog before submitting an opportunity request.
 * Wraps the shared ConfirmDialog component.
 */
export default function ConfirmRequestDialog({ open, onConfirm, onCancel }: Props) {
  return (
    <ConfirmDialog
      open={open}
      title={DIALOG_TITLE}
      description={DIALOG_DESCRIPTION}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmText="Confirmar"
      cancelText="Cancelar"
    />
  );
}
